import api from './client';
import ApiError from './error';

const AuthService = {
  async authenticate({ email, password }) {
    try {
      const client = await api.getClient();
      return await client.passwordAuthenticate(null, {
        email,
        password,
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async renewToken() {
    try {
      const client = await api.getClient();

      client.interceptors.response.use((response) => response, (error) => {
        // On failed renew the api returns status 403
        if (error.response?.status === 403) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return await client.renewBearerToken();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default AuthService;
